import type { StockAuditScanResult } from '../../../types/stockAudit';

export const SCAN_RESULT_LABELS: Record<StockAuditScanResult, string> = {
  FOUND: 'Знайдено',
  UNEXPECTED_SOLD: 'Продано, але лежить на складі',
  UNEXPECTED_OTHER_STOCK: 'Числиться на іншому складі',
  UNKNOWN: 'Немає в системі',
  OUT_OF_SCOPE: 'Поза фільтром ревізії',
  DUPLICATE: 'Вже скановано',
};

export const isUnexpectedResult = (result: StockAuditScanResult): boolean =>
  result === 'UNEXPECTED_SOLD' || result === 'UNEXPECTED_OTHER_STOCK' || result === 'UNKNOWN';
